/* eslint-disable unicorn/filename-case -- TODO rename later */
import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

import { IstariDigitalLogo } from "../../assets/svg";
import Button from "../../components/__deprecated/Button";

const FullScreenLoading = () => (
  <div role="status" aria-live="polite" data-testid="auth-loading-spinner">
    <span className="sr-only">Loading</span>
  </div>
);

interface AuthErrorBoundaryProps {
  children: React.ReactNode;
}

function AuthErrorBoundary({ children }: AuthErrorBoundaryProps) {
  const [hasAuthenticationErrors, setHasAuthenticationErrors] = useState(false);

  const auth = useAuth();

  useEffect(() => {
    if (auth && auth.isAuthenticated) {
      window.localStorage.setItem("istari-user", JSON.stringify(auth.user));
    }
    if (auth && auth.error) {
      setHasAuthenticationErrors(true);
    }
  }, [auth, auth.isAuthenticated]);

  switch (auth.activeNavigator) {
    case "signinSilent":
    case "signoutRedirect":
      return <FullScreenLoading />;
    default:
  }

  if (auth.isLoading) {
    return <FullScreenLoading />;
  }

  if (hasAuthenticationErrors) {
    return (
      <div className="flex h-screen w-full justify-center bg-[#f3f3f3] text-center">
        <div className="mt-[50px]">
          <IstariDigitalLogo height="40px" />
          <div className="justify-center gap-y-[10px]">
            <h4 className="text-[2rem] leading-[125%] font-bold text-gray-800">You are signed out.</h4>
            <span className="text-sm font-semibold text-gray-700">Please click the button to log in again.</span>
          </div>
          <div className="mt-[30px]">
            <Button fullWidth label="Login" variant="primary" onClick={() => window.location.reload()} />
          </div>
        </div>
      </div>
    );
  }

  return children;
}

export default AuthErrorBoundary;
